export const isEmail = (email: string) => {
  const emailRegex = /^[\w.-]+@[\w.-]+\.[\w.-]+$/;
  return !!email && emailRegex.test(email.trim());
};

export const isPhoneNumber = (phone: string) => {
  const regex = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/gm;
  return regex.test(phone)
};

export const isIsraeliIdValid = (id: string) => {
  let strId = String(id).trim();
  if (strId.length > 9) {
    return false;
  }
  if (strId.length < 9) {
    while (strId.length < 9) strId = "0" + strId;
  }
  let counter = 0, rawVal, actualVal;
  for (let i = 0; i < strId.length; i++) {
    rawVal = Number(strId[i]) * ((i % 2) + 1);
    actualVal = rawVal > 9 ? (rawVal - 9) : rawVal;
    counter += actualVal;
  }
  return (counter % 10 === 0);
};